import { useNavigate } from 'react-router-dom'
import { useAuth0 } from "@auth0/auth0-react"
import { useAppSelector, useAppDispatch } from '../../app/hooks'
import { SaveIcon } from '../../images/Icons'
import { 
    addEventUserAsync, 
    selectCurrentEventUserStatus
} from './currentEventUserSlice'
import '../../App.css'
import { addInvitationAsync } from '../invitation/invitationSlice';

export function SaveEventUserButton() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const { isAuthenticated, getAccessTokenSilently, user } = useAuth0()
    const currentEventUserStatus = useAppSelector(selectCurrentEventUserStatus)

    return (
        <div className='iconButton' onClick={async () => {
            if (isAuthenticated && user?.email) { 
                  
                const accessToken = await getAccessTokenSilently({ authorizationParams : {
                }})
                    dispatch(addEventUserAsync( { 
                        token: accessToken
                        }))
                    if (currentEventUserStatus === 'idle') {
                        dispatch (addInvitationAsync(
                            {
                                token: accessToken
                            }
                        ))
                        if (currentEventUserStatus === 'idle') {

                            navigate(-1)
                        }
                    } else {
                        alert (`Not expected status '${ currentEventUserStatus }'`)
                    }
                
            }
        }}>
            <SaveIcon />
        </div>
    )
}